import axios from 'axios';

const API_URL = 'https://api.weartoday.kr/api';

const getAuthHeaders = () => {
	const token = localStorage.getItem('access_token');
	return {
		'Authorization': `Bearer ${token}`,
		'Content-Type': 'application/json'
	};
};

export const getProfile = async () => {
	try {
		console.log('📦 프로필 요청...');
		const response = await axios.get(`${API_URL}/users/profile/`, {
			headers: getAuthHeaders()
		});
		console.log('✅ 프로필 응답:', response.data);
		return response.data;
	} catch (error) {
		console.error('❌ 프로필 로딩 실패:', error);
		throw error;
	}
};

export const updateProfile = async (data) => {
	try {
		console.log('📝 프로필 수정 요청:', data);
		const response = await axios.put(
			`${API_URL}/users/profile/update/`,
			data,
			{
				headers: getAuthHeaders()
			}
		);
		console.log('✅ 프로필 수정 성공:', response.data);
		return response.data;
	} catch (error) {
		console.error('❌ 프로필 수정 실패:', error);
		throw error;
	}
};

export const checkShippingInfo = async () => {
	try {
		const response = await axios.post(
			`${API_URL}/users/check-shipping-info/`,
			{},
			{
				headers: getAuthHeaders()
			}
		);
		return response.data;
	} catch (error) {
		console.error('❌ 배송 정보 확인 실패:', error);
		throw error;
	}
};

export const verifyCustoms = async (name, phone, customs_number) => {
	try {
		console.log('🔍 개인통관번호 검증 요청...');
		const response = await axios.post(
			`${API_URL}/users/verify_customs/`,
			{
				name,
				phone,
				customs_number
			},
			{
				headers: getAuthHeaders()
			}
		);
		console.log('✅ 검증 성공:', response.data);
		return response.data;
	} catch (error) {
		console.error('❌ 검증 실패:', error);
		throw error;
	}
};

// ✅ 이메일 인증 API 추가
export const sendVerificationCode = async (email) => {
	try {
		console.log('📧 인증코드 발송 요청:', email);
		const response = await axios.post(
			`${API_URL}/users/send-verification-code/`,
			{ email },
			{
				headers: getAuthHeaders()
			}
		);
		console.log('✅ 인증코드 발송 성공');
		return response.data;
	} catch (error) {
		console.error('❌ 인증코드 발송 실패:', error);
		throw error;
	}
};

export const verifyEmailCode = async (email, code) => {
	try {
		console.log('🔍 인증코드 확인 요청:', email, code);
		const response = await axios.post(
			`${API_URL}/users/verify-email-code/`,
			{ email, code },
			{
				headers: getAuthHeaders()
			}
		);
		console.log('✅ 이메일 인증 완료');
		return response.data;
	} catch (error) {
		console.error('❌ 인증코드 확인 실패:', error);
		throw error;
	}
};